import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Helmet } from "react-helmet";
import ReactGA from 'react-ga';

// Components
import MarketingHeader from '../components/Marketing/MarketingHeader';
import MarketingEmailCallout from '../components/Marketing/MarketingEmailCallout';
import MarketingFooter from '../components/Marketing/MarketingFooter';

// Image Imports
import PlaceholderImage from '../assets/images/placeholder-image.jpg';

import {getZohoPagesense} from '../utils/helpers'

class MarketingContent extends Component {
  static propTypes = {
    location: PropTypes.string.isRequired
  }

  componentDidMount(){
    getZohoPagesense();
    ReactGA.pageview('/MarketingContent');
  }

  render() {
    const { appName } = this.props;

    return (
      <div>
        <Helmet>
          <title>{appName} | Content</title>
        </Helmet>
        <MarketingHeader
          path={this.props.location}
          appName={this.props.appName}
        />
        <section className="hero">
          <div className="mini-wrap">
            <h1>General Content Page</h1>
            <p>
              This page could house Terms of Service, Privacy Policy and more. This page is a basic template with the content.
                </p>
          </div>
        </section>
        <section className="content">
          <div className="inner-wrap">
            <div className="section-header">
              <h2>History Of Lorem Ipsum</h2>
              <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. </p>
            </div>
            <div className="image" style={{ backgroundImage: `url(${PlaceholderImage})` }}></div>
            <h3>Lorem Ipsum Begins</h3>
            <p>
              Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old. Richard McClintock, a Latin professor at Hampden-Sydney College in Virginia, looked up one of the more obscure Latin words, consectetur, from a Lorem Ipsum passage, and going through the cites of the word in classical literature, discovered the undoubtable source. Lorem Ipsum comes from sections 1.10.32 and 1.10.33 of "de Finibus Bonorum et Malorum" (The Extremes of Good and Evil) by Cicero, written in 45 BC. This book is a treatise on the theory of ethics, very popular during the Renaissance. The first line of Lorem Ipsum, "Lorem ipsum dolor sit amet..", comes from a line in section 1.10.32.
                </p>
            <p>
              The standard chunk of Lorem Ipsum used since the 1500s is reproduced below for those interested. Sections 1.10.32 and 1.10.33 from "de Finibus Bonorum et Malorum" by Cicero are also reproduced in their exact original form, accompanied by English versions from the 1914 translation by H. Rackham.
                </p>
            <h3>Lorem Ipsum Begins</h3>
            <p>
              Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old. Richard McClintock, a Latin professor at Hampden-Sydney College in Virginia, looked up one of the more obscure Latin words, consectetur, from a Lorem Ipsum passage, and going through the cites of the word in classical literature, discovered the undoubtable source. Lorem Ipsum comes from sections 1.10.32 and 1.10.33 of "de Finibus Bonorum et Malorum" (The Extremes of Good and Evil) by Cicero, written in 45 BC. This book is a treatise on the theory of ethics, very popular during the Renaissance. The first line of Lorem Ipsum, "Lorem ipsum dolor sit amet..", comes from a line in section 1.10.32.
                </p>
            <p>
              The standard chunk of Lorem Ipsum used since the 1500s is reproduced below for those interested. Sections 1.10.32 and 1.10.33 from "de Finibus Bonorum et Malorum" by Cicero are also reproduced in their exact original form, accompanied by English versions from the 1914 translation by H. Rackham.
                </p>
          </div>
        </section>
        <MarketingEmailCallout appName={this.props.appName} />
        <MarketingFooter appName={this.props.appName} companyAddress={this.props.companyAddress}
          adminEmail={this.props.adminEmail} />
      </div>
    );
  }
}

export default MarketingContent;
